
import React, { useState, useEffect } from "react";
// import Logo from "../dist/images/tc-logo-horizontal-gold.png";
import Logo from "../dist/images/tc-logo-horizontal.png"
import { Link } from "react-router-dom";
import { MenuData } from "./MenuData";
import { getToken, resetUserSession } from "../service/AuthService"; 
import { useNavigate } from "react-router-dom";

import "../styles/font-awesome-4.7.0/css/font-awesome.min.css";
import "../styles/Navbar.css";

function Navbar() {
  const [openLinks, setOpenLinks] = useState(false);
  const [clicked, setClicked] = useState(false);
  const navigate = useNavigate();

  // Check if token exists to determine if user is logged in
  const token = getToken();
  const isLoggedIn = token !== null && token !== undefined && token !== 'undefined'; 
  
  const  handleClick = () => {
    setClicked(!clicked);
  }

  const toggleNavbar = () => {
    setOpenLinks(!openLinks);
  };

  const handleLogout = () => {
    resetUserSession(); 
    navigate("/");
  };

  

  return (

    <nav className="navbar" id="navbar">
      <div className="logo">
        <Link to="/">
          <img src={Logo} alt="Brand Logo" />
        </Link>
      </div>

      <div className="menu-icons" onClick={handleClick}>
        <i className={clicked ? "fa fa-times" : "fa fa-bars"}></i>
      </div>
      <ul className={clicked ? "nav-menu active font-medium" : "nav-menu font-medium"}>
        {MenuData.map((item, index) => {
          const title = item.title.toLowerCase();
          if (title === "sign up" && isLoggedIn) return null; // Do not render "Sign up" if logged in
          if (title === "logout" && !isLoggedIn) return null; // Only show "Logout" if the user is logged in

          return (
            <li key={index}>
              <a
                href={item.url}
                className={item.cName}
                onClick={item.title === "LOGOUT" ? handleLogout : null}  // Logout handler for "Logout" menu item
              >
                <i className={item.icon}></i> {item.title}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
{/*
    <div className="navbar">
      <div className="leftSide" id={openLinks ? "open" : "close"}>
        <img src={Logo} alt="Logo"/> 
        <div className="hiddenLinks">
          <Link to="/" style={{ margin: "1rem" }}> Home </Link>
          <Link to="/Register"> Register </Link>
          <Link to="/Login"> Login </Link>
          <Link to="/Customer" style={{ margin: "1rem" }}> Dashboard </Link>
          <Link to="/ContactUs" style={{ margin: "1rem" }}> Contact </Link>
        </div>
      </div>
      <div className="rightSide">
        <Link to="/"> Home </Link>
        <Link to="/Register"> Register </Link>
        <Link to="/Login"> Login </Link>
        <Link to="/Customer"> Dashboard </Link>
        <Link to="/ContactUs"> Contact </Link>
        <button onClick={toggleNavbar}>
          <ReorderIcon />
        </button>
      </div>
    </div>
*/}

export default Navbar;